/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import {
  baseApiV2_1,
  baseApiV2_2,
  baseApiV3,
  baseApiV3_1,
  clientApiV2,
} from "../../constants/Presets";

// function that makes the api request and returns a Promise for response
export function FetchPlayers(payload) {
  return axios.get(`${clientApiV2}?templateFlag=false&companyId=${payload}`);
}
export function FetchAPlayer(id) {
  return axios.get(`${clientApiV2}?playerId=${id}`);
}
export function FetchAPlayerV3(id, company) {
  const parameter = company ? { company_id: company } : {};
  return axios.get(
    `${baseApiV3}collector?collector_id=${id}&template_flag=false`,
    {
      params: parameter,
    },
  );
}
// export function FetchAPlayerV3_1(id, company) {
//   const parameter = company ? { company_id: company } : {};
//   return axios.get(
//     `${baseApiV3_1}collector/list&template_flag=false`,

//     {
//       params: parameter,
//     },
//   );
// }
export function FetchAPlayerForAddDatapipe(payload) {
  return axios.get(`${baseApiV2_2}collector_config/${payload}`);
}
export function FetchPlayerList(payload) {
  return axios.get(
    `${baseApiV3}players?basic_only=${payload.status}&company_id=${payload.id}`,
  );
}
